import { Dispatch, SetStateAction } from "react";
import { VideoJsPlayer, VideoJsPlayerOptions } from "video.js";
export interface BaseVideoOptions {
  autoplay?: boolean;
  responsive?: boolean;
  fluid: boolean;
  fill?: boolean;
  source: {
    src: string;
    type?: "video/mp4" | "application/x-mpegURL";
  };
}

export type PlayerAction = {
  action:
    | "play"
    | "pause"
    | "end"
    | "stop"
    | "skipTime"
    | "selectQualityIndex"
    | "volumeLevel"
    | "toggleFullScreen"
    | "toggleMute";
  value?: number;
};

export interface BaseVideoProps {
  customControls: JSX.Element;
  playerType: "videojs" | "modern-videojs" | "shaka";
  options: BaseVideoOptions;
  action: PlayerAction;
  state: PlayerState;
  onState: Dispatch<SetStateAction<PlayerState>>;
}

export interface BaseVideoJsProps {
  customControls: JSX.Element;
  options: VideoJsPlayerOptions;
  action: PlayerAction;
  state: PlayerState;
  onState: Dispatch<SetStateAction<PlayerState>>;
}

export interface BaseShakaProps {
  options: ShakaPlayerOptions;
  action: PlayerAction;
  onState: Dispatch<SetStateAction<PlayerState>>;
}

export interface ShakaPlayerOptions {}

export interface PlayerState {
  isReady: boolean;
  isAbort: boolean;
  isPlaying: boolean;
  isEnded: boolean;
  isLoading: boolean;
  isSeeking: boolean;
  isMuted: boolean;
  isFullScreen: boolean;
  canFullScreen: boolean;
  duration: number;
  currentTime: number;
  qualityList: QualityItem[];
  currentQuality?: QualityItem;
  currentVolumeLevel: number;
  selectedQuality: number;
  videoHeight?: number;
  videoWidth?: number;
}

export const initialPlayerState: PlayerState = {
  isReady: false,
  isAbort: false,
  isPlaying: false,
  isEnded: false,
  isLoading: false,
  isSeeking: false,
  isMuted: false,
  isFullScreen: false,
  canFullScreen: false,
  duration: -1,
  currentVolumeLevel: 1,
  currentTime: -1,
  qualityList: [],
  selectedQuality: -1
};

export interface QualityItem {
  id?: string;
  width?: number;
  height?: number;
  bitrate?: number;
  frameRate?: number;
  enabled?: boolean;
  label?: string;
}

// @ts-ignore
export interface ExtendedVideoJsPLayer extends VideoJsPlayer {
  qualityLevels: () => {
    on: (event: string, callback: () => void) => void;
    levels_: QualityItem[];
    selectedIndex: number;
  };
}

export interface BaseVideoControls {
  state: PlayerState;
  setAction: Dispatch<SetStateAction<PlayerAction>>;
}
